<template>
    <div class="container-fluid">
      <header-title></header-title>

      <div class="content-wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-4 col-md-3 sidebar-wrapper">
          </div>

          <div class="col-xs-12 col-sm-8 col-md-9">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import HeaderTitle from '../Header/';
import swal from "sweetalert2";

export default {
  components: {
    HeaderTitle,
  },

  created() {
    swal({
      title: "Ops!",
      text: "Não conseguimos encontrar o usuário. Recarregue a página e tente novamente.",
      type: "error",
      closeOnConfirm: false,
      closeOnCancel: false,
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
    })
  }
}
</script>

<style>
body{
  background:#f0f3f7!important;
}
.content-wrapper{
  background: #fff;
  padding: 25px;
  border: 1px solid #D9DDE4;
  display: table;
  border-radius: 3px!important;
  width: 100%;
}
.sidebar-wrapper{
  border-right:1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Errors/Auth.vue